import React from 'react';
import useAuth from 'src/hooks/useAuth';
import { OrgAppRolesProvider } from 'src/hooks/useOrgAppRoles';
import useOrgUserDetails from 'src/hooks/useOrgUserDetails';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import GoBackButton from '../GoBackButton/GoBackButton';
import Loader from '../Loader/Loader';
import OrgUserDetails from './OrgUserDetails';

interface OrgUserDetailsLoaderProps {
  orgId: string;
  userId: string;
}

const OrgUserDetailsLoader: React.FC<OrgUserDetailsLoaderProps> = ({
  orgId,
  userId,
}) => {
  const { user } = useAuth();
  const { userDetails, isLoading, error } = useOrgUserDetails();

  if (isLoading) {
    return <Loader height={300} />;
  }

  if (error) {
    return (
      <>
        <GoBackButton />
        <ErrorMessage />;
      </>
    );
  }

  if (userDetails) {
    return (
      <>
        <GoBackButton defaultPath="/organisation?tab=users" />
        <OrgAppRolesProvider>
          <OrgUserDetails disableActions={user.id === userDetails.UID} />
        </OrgAppRolesProvider>
      </>
    );
  }

  return null;
};

export default OrgUserDetailsLoader;
